import React from 'react';
import './GlassCandles.css';

const GlassCandles = ({ isMobileDevice, isSafari, isMac }) => {
  // Define the candles with their specific attributes for the 3D look
  const candles = [
    { id: 1, width: 60, bodyHeight: 180, wickHeight: 280, yOffset: -30, delay: '0s', gradient: 'grad-1' },
    { id: 2, width: 60, bodyHeight: 120, wickHeight: 200, yOffset: 40, delay: '-1s', gradient: 'grad-2' },
    { id: 3, width: 60, bodyHeight: 220, wickHeight: 320, yOffset: -50, delay: '-2.5s', gradient: 'grad-3' },
    { id: 4, width: 60, bodyHeight: 150, wickHeight: 240, yOffset: 10, delay: '-1.5s', gradient: 'grad-4' },
    { id: 5, width: 60, bodyHeight: 190, wickHeight: 300, yOffset: -20, delay: '-0.5s', gradient: 'grad-1' },
    { id: 6, width: 60, bodyHeight: 130, wickHeight: 220, yOffset: 50, delay: '-3s', gradient: 'grad-2' },
  ];

  return (
    <div className={`glass-candles-section ${isMobileDevice ? 'mobile-optimized' : ''} ${isSafari ? 'is-safari' : ''} ${isMac ? 'is-mac' : ''}`}>
      {/* Decorative Grid Background to match the dark futuristic fintech theme */}
      <div className="candles-grid-bg"></div>
      
      <div className="candles-scene">
        {candles.map((candle) => (
          <div 
            key={candle.id} 
            className="candle-container"
            style={{ 
              marginTop: `${candle.yOffset}px`,
            }}
          >
            <div 
              className="candle-wrapper"
              style={{ 
                width: `${candle.width}px`,
                height: `${candle.bodyHeight}px`,
                animationDelay: candle.delay
              }}
            >
              <div 
                className="candle-wick" 
                style={{ height: `${candle.wickHeight}px` }}
              ></div>
              <div 
                className="candle-prism" 
                style={{ height: `${candle.bodyHeight}px` }}
              >
                <div className="prism-face front"></div>
                <div className="prism-face back"></div>
                <div className="prism-face left"></div>
                <div className="prism-face right"></div>
                <div className="prism-face top"></div>
                <div className="prism-face bottom"></div>
                <div className={`prism-core ${candle.gradient}`}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GlassCandles;
